import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef ,useState} from 'react';
import Grid from '@mui/material/Grid';
import { createSearchParams, useLocation } from "react-router-dom";
import { store } from '../helpers/store';
import { setPageLoadFinish, setPageLoading } from '../slices/page.slice';
import { fetchInvoices, invoiceItemsSelector, setInvoiceLoading, setInvoiceSearchKeyDeliverylocationumber, setInvoiceSearchKeyFromdate, setInvoiceSearchKeySaletype, setInvoiceSearchKeyTodate, setInvoiceSearchKeyNumber, setInvoiceSearchKey, clearInvoiceFilters, fetchInvoice, setSelectedInvoiceId } from "../slices/invoices.slice";
import DataGrid from 'react-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Checkbox from '@mui/material/Checkbox';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { pink } from '@mui/material/colors';
import SvgIcon from '@mui/material/SvgIcon';
import DehazeIcon from '@mui/icons-material/Dehaze';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import TextField from '@mui/material/TextField';
import DatePicker from "react-multi-date-picker"
import { Calendar } from "react-multi-date-picker"
import moment from 'jalali-moment'
import Tooltip from '@mui/material/Tooltip';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import JalaliUtils from "@date-io/jalaali";
import SearchIcon from '@mui/icons-material/Search';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Modal from "@material-ui/core/Modal";
import { useNavigate } from "react-router-dom";
import { fetchAccountReview } from '../slices/accountReview.slice';
import { SpatialTrackingSharp } from '@mui/icons-material';
import { clearReceiptsFilters, fetchCashReceipts, fetchChequeReceipts, fetchDraftReceipts, fetchPosReceipts, setReceiptsSearchKey, setReceiptsSearchKeyFromdate, setReceiptsSearchKeyTodate } from '../slices/receipts.slice';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PaymentIcon from '@mui/icons-material/Payment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

export const zeroPad = (num, places) => String(num).padStart(places, '0');


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}


export const Receipts = (props) => {
  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);
  const authUser = JSON.parse(localStorage.getItem('user'));

  const receipts = useSelector(x => x.receipts);
  const defaultValues1 = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));


  let navigate = useNavigate();
 
  const columnsCheques = [
    {
      name: 'ردیف',
      key: 'rowIndex',
      width: '1%',
    }, 
    {
      key: 'Number',
      name: 'شماره',
      width: '15%',
      resizable: true,
      sortable: true,
      
    },
    {
      key: 'Date',
      name: 'تاریخ',
      width: '10%',
      resizable: true,
      sortable: true
    },
    {
      key: 'Amount_sh',
      name: 'مبلغ',
      width: '15%',
      resizable: true,
      sortable: true,
  
    },
    {
      key: 'Bank',
      name: 'بانک',
      width: '10%',
      resizable: true,
      sortable: true
    },
    {
      key: 'BankBranch',
      name: 'شعبه',
      width: '10%',
      resizable: true,
      sortable: true
    },
    {
      key: 'State',
      name: 'وضعیت',
      width: '10%',
      resizable: true,
      sortable: true
    },
    {
      key: 'Description',
      name: 'شرح',
      width: '29%',
      resizable: true,
      sortable: true
    }
  ];
  const columnsPoses = [
    {
      name: 'ردیف',
      key: 'rowIndex',
      width: '1%',
    },
    {
      key: 'Date',
      name: 'تاریخ',
      width: '10%',
      resizable: true,
      sortable: true,
      
    },
    {
      key: 'Amount_sh',
      name: 'مبلغ',
      width: '20%',
      resizable: true,
      sortable: true,
  
    },
    
    {
      key: 'TrackingCode',
      name: 'پیگیری',
      width: '69%',
      resizable: true,
      sortable: true
    }
  ];
const columnsDrafts = [
  {
    name: 'ردیف',
    key: 'rowIndex',
    width: '1%',
  }, 
  {
    key: 'Number',
    name: 'شماره',
    width: '15%',
    resizable: true,
    sortable: true,
    
  },
  {
    key: 'Date',
    name: 'تاریخ',
    width: '10%',
    resizable: true,
    sortable: true
  },
  {
    key: 'Amount_sh',
    name: 'مبلغ',
    width: '15%',
    resizable: true,
    sortable: true,

  },
  
  {
    key: 'Description',
    name: 'شرح',
    width: '59%',
    resizable: true,
    sortable: true
  }
];
const columnsCashes = [
  {
    name: 'ردیف',
    key: 'rowIndex',
    width: '1%',
  }, 
  {
    key: 'Number',
    name: 'شماره',
    width: '15%',
    resizable: true,
    sortable: true,
    
  },
  {
    key: 'Date',
    name: 'تاریخ',
    width: '10%',
    resizable: true,
    sortable: true
  },
  {
    key: 'Amount_sh',
    name: 'مبلغ',
    width: '15%',
    resizable: true,
    sortable: true,

  },
  
  {
    key: 'Description',
    name: 'شرح',
    width: '59%',
    resizable: true,
    sortable: true
  }
];

   useEffect(() => {

      if(receipts.fetchPermission){
        dispatch(fetchDraftReceipts({hasMore: true, pageindex: 0 , fromdate: defaultValues.FiscalYearStartDate , todate :  defaultValues.FiscalYearEndDate , authUser}));
        dispatch(fetchCashReceipts({hasMore: true, pageindex: 0 , fromdate: defaultValues.FiscalYearStartDate , todate :  defaultValues.FiscalYearEndDate , authUser}));
        dispatch(fetchChequeReceipts({hasMore: true, pageindex: 0 , fromdate: defaultValues.FiscalYearStartDate , todate :  defaultValues.FiscalYearEndDate , authUser}));
        dispatch(fetchPosReceipts({hasMore: true, pageindex: 0 , fromdate: defaultValues.FiscalYearStartDate , todate :  defaultValues.FiscalYearEndDate , authUser}));

      }

   }, []);

   const onSearchHandler = (e) =>{

    if(receipts.fetchPermission){
      dispatch(fetchDraftReceipts({hasMore: true, pageindex: 0 , fromdate: (receipts.searchKey_fromdate === '' ? defaultValues.FiscalYearStartDate : receipts.searchKey_fromdate) , todate :  (receipts.searchKey_todate === '' ?defaultValues.FiscalYearEndDate : receipts.searchKey_todate ) , authUser}));
      dispatch(fetchCashReceipts({hasMore: true, pageindex: 0 , fromdate: (receipts.searchKey_fromdate === '' ? defaultValues.FiscalYearStartDate : receipts.searchKey_fromdate) , todate :  (receipts.searchKey_todate === '' ?defaultValues.FiscalYearEndDate : receipts.searchKey_todate ) , authUser}));
      dispatch(fetchChequeReceipts({hasMore: true, pageindex: 0 , fromdate: (receipts.searchKey_fromdate === '' ? defaultValues.FiscalYearStartDate : receipts.searchKey_fromdate) , todate :  (receipts.searchKey_todate === '' ?defaultValues.FiscalYearEndDate : receipts.searchKey_todate ) , authUser}));
      dispatch(fetchPosReceipts({hasMore: true, pageindex: 0 , fromdate: (receipts.searchKey_fromdate === '' ? defaultValues.FiscalYearStartDate : receipts.searchKey_fromdate) , todate :  (receipts.searchKey_todate === '' ?defaultValues.FiscalYearEndDate : receipts.searchKey_todate ) , authUser}));

    }

  }

  function rowKeyGetter(row) {
    return row.ID;
  }

  //#region Draft
   async function handleScrollDraft(event) {
    if (receipts.loadingDrafts || !isAtBottomDraft(event)) return;


    await loadMoreRowsDraft();

    //setRows([...rows, ...newRows]);
    //setIsLoading(false);
  }
  function EmptyRowsRendererDraft() {
    return (
    
      <div style={{ textAlign: 'center', gridColumn: '1/-1' }}>
        {receipts.loadingDrafts ? '' :   ' اطلاعاتی برای نمایش وجود ندارد' }
      </div>
    );
  }
  function isAtBottomDraft({ currentTarget }) {
    if(currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight){
        //console.log("isAtBottom");     
    }
    return currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight;
  }
  
  function loadMoreRowsDraft() {
    //console.log("currentPageIndex for load more"); 
    ///dispatch(setLoading());
    dispatch(fetchDraftReceipts({hasMore: receipts.hasMore, pageindex: receipts.currentPageIndex , fromdate:  defaultValues.FiscalYearStartDate , todate : defaultValues.FiscalYearEndDate , authUser}));
  }

  
   let dataSourceDrafts  = [];

   if(receipts.draftItems !== undefined && receipts.draftItems.length > 0)
   {
       dataSourceDrafts = receipts.draftItems.map((item, i) => ({...item, rowIndex : i+1}));
   }
   const dynamicHeightDrafts = Math.min(receipts.draftItems.length * 6 + 20, 75) + 'vh';
  //#endregion

  
  //#region Cheque
  async function handleScrollCheque(event) {
    if (receipts.loadingCheques || !isAtBottomCheque(event)) return;


    await loadMoreRowsCheque();

    //setRows([...rows, ...newRows]);
    //setIsLoading(false);
  }
  function EmptyRowsRendererCheque() {
    return (
    
      <div style={{ textAlign: 'center', gridColumn: '1/-1' }}>
        {receipts.loadingCheques ? '' :   ' اطلاعاتی برای نمایش وجود ندارد' }
      </div>
    );
  }
  function isAtBottomCheque({ currentTarget }) {
    if(currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight){
        //console.log("isAtBottom");     
    }
    return currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight;
  }
  
  function loadMoreRowsCheque() {
    //console.log("currentPageIndex for load more"); 
    ///dispatch(setLoading());
    dispatch(fetchChequeReceipts({hasMore: receipts.hasMore, pageindex: receipts.currentPageIndex , fromdate:  defaultValues.FiscalYearStartDate , todate : defaultValues.FiscalYearEndDate , authUser}));
  }

  
   let dataSourceCheques  = [];

   if(receipts.chequeItems !== undefined && receipts.chequeItems.length > 0)
   {
       dataSourceCheques = receipts.chequeItems.map((item, i) => ({...item, rowIndex : i+1}));
   }
   const dynamicHeightCheques = Math.min(receipts.chequeItems.length * 6 + 20, 75) + 'vh';
  //#endregion

  


   //#region Pos
   async function handleScrollPos(event) {
    if (receipts.loadingPoses || !isAtBottomPos(event)) return;


    await loadMoreRowsPos();

    //setRows([...rows, ...newRows]);
    //setIsLoading(false);
  }
  function EmptyRowsRendererPos() {
    return (
    
      <div style={{ textAlign: 'center', gridColumn: '1/-1' }}>
        {receipts.loadingPoses ? '' :   ' اطلاعاتی برای نمایش وجود ندارد' }
      </div>
    );
  }
  function isAtBottomPos({ currentTarget }) {
    if(currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight){
        //console.log("isAtBottom");     
    }
    return currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight;
  }
  
  function loadMoreRowsPos() {
    //console.log("currentPageIndex for load more"); 
    ///dispatch(setLoading());
    dispatch(fetchPosReceipts({hasMore: receipts.hasMore, pageindex: receipts.currentPageIndex , fromdate:  defaultValues.FiscalYearStartDate , todate : defaultValues.FiscalYearEndDate , authUser}));
  }

  
   let dataSourcePoses  = [];

   if(receipts.posItems !== undefined && receipts.posItems.length > 0)
   {
       dataSourcePoses = receipts.posItems.map((item, i) => ({...item, rowIndex : i+1}));
   }
   const dynamicHeightPoses = Math.min(receipts.posItems.length * 6 + 20, 75) + 'vh';
  //#endregion


  //#region Cash
  async function handleScrollCash(event) {
    if (receipts.loadingCashes || !isAtBottomCash(event)) return;


    await loadMoreRowsCash();

    //setRows([...rows, ...newRows]);
    //setIsLoading(false);
  }
  function EmptyRowsRendererCash() {
    return (
    
      <div style={{ textAlign: 'center', gridColumn: '1/-1' }}>
        {receipts.loadingCashes ? '' :   ' اطلاعاتی برای نمایش وجود ندارد' }
      </div>
    );
  }
  function isAtBottomCash({ currentTarget }) {
    if(currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight){
        //console.log("isAtBottom");     
    }
    return currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight;
  }
  
  function loadMoreRowsCash() {
    //console.log("currentPageIndex for load more"); 
    ///dispatch(setLoading());
    dispatch(fetchCashReceipts({hasMore: receipts.hasMore, pageindex: receipts.currentPageIndex , fromdate:  defaultValues.FiscalYearStartDate , todate : defaultValues.FiscalYearEndDate , authUser}));
  }

  
   let dataSourceCashes  = [];

   if(receipts.cashItems !== undefined && receipts.cashItems.length > 0)
   {
       dataSourceCashes = receipts.cashItems.map((item, i) => ({...item, rowIndex : i+1}));
   }
   const dynamicHeightCashes = Math.min(receipts.cashItems.length * 6 + 20, 75) + 'vh';
  //#endregion

  const onSearchChange = (e) =>{

    dispatch(setReceiptsSearchKey(e.target.value));
  }
  
  const onFromDateSelectedHandler = (e) =>{
    var day = zeroPad(e.day , 2);
    var month = zeroPad(e.month.number , 2);
    var year = e.year;
  
    dispatch(setReceiptsSearchKeyFromdate(year + "/" + month + "/"+ day));
    
  }
  const onToDateSelectedHandler = (e) =>{
    var day = zeroPad(e.day , 2);
    var month = zeroPad(e.month.number , 2);
    var year = e.year;
    dispatch(setReceiptsSearchKeyTodate(year + "/" + month + "/"+ day));
  }

   const mdTheme = createTheme({
    typography: {
      fontFamily: [
        "mohammadfont",
        "Tahoma",
        "Verdana"
      ].join(",")
    },
    direction: 'rtl',
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: '#FBC02D',
            color: '#424242'
          },
        },
      },
    }
  });

const onSearchHandlerDraft = (e) =>{

  dispatch(fetchDraftReceipts({hasMore: true, pageindex: 0 , fromdate: defaultValues.FiscalYearStartDate , todate : defaultValues.FiscalYearEndDate , authUser}));

}
const onClearFilterHandler = (e) =>{

  dispatch(clearReceiptsFilters());

}
const onClearFilterHandlerDraft = (e) =>{

  //dispatch(clearInvoiceFilters());

}

const onSearchChangeDraft = (e) =>{

  //dispatch(setInvoiceSearchKey(e.target.value));
}

const onFromDateSelectedHandlerDraft = (e) =>{
  var day = zeroPad(e.day , 2);
  var month = zeroPad(e.month.number , 2);
  var year = e.year;

  //dispatch(setInvoiceSearchKeyFromdate(year + "/" + month + "/"+ day));
  
}
const onToDateSelectedHandlerDraft = (e) =>{
  var day = zeroPad(e.day , 2);
  var month = zeroPad(e.month.number , 2);
  var year = e.year;
  //dispatch(setInvoiceSearchKeyTodate(year + "/" + month + "/"+ day));
}


const theme = useTheme();
const [value, setValue] = React.useState(0);

const handleChange = (event, newValue) => {
  setValue(newValue);
};

const handleChangeIndex = (index) => {
  setValue(index);
};

  return (
    <>

<ThemeProvider theme={mdTheme}>
      <AppBar position="sticky" style={{ background: '#ffffff' }}>
        <Tabs 
          //orientation="vertical"
          value={value}
          onChange={handleChange}
          textColorPrimary="#ff0000"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="واریزی ها" icon={<AccountBalanceIcon />} {...a11yProps(0)} />
          <Tab label="چک ها" icon={<PaymentIcon />} {...a11yProps(1)} />
          <Tab label="کارت خوان" icon={<CreditScoreIcon />} {...a11yProps(2)} />
          <Tab label="نقدی" icon={<AttachMoneyIcon />} {...a11yProps(3)} />
        </Tabs>
      </AppBar>

      <Accordion defaultExpanded={false}>
                          <AccordionSummary
                           expandIcon={<FilterAltIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                          >
                    <Typography sx={{ width: '33%', flexShrink: 0 }}>
            فهرست پرداخت های من
          </Typography>
          <Typography sx={{ color: 'text.secondary' }}>برای جستجو کلیک کنید</Typography>

                </AccordionSummary>
                  <AccordionDetails>
                  <span className='fontSize14'>
                  جستجو:
              </span>
                  <TextField value={receipts.searchKey} size="small" label="عبارت جستجو" variant="outlined" onChange={onSearchChange} />
                  <span className='fontSize14'>
                  از:
              </span>
                <DatePicker value={receipts.searchKey_fromdate}
                            onChange={onFromDateSelectedHandler}
                            calendar={persian}
                            locale={persian_fa}
                            animation="true"
                            inputClass="dateCss"
                          />
                  <span className='fontSize14'>
                  تا:
              </span>
                <DatePicker value={receipts.searchKey_todate}
                            onChange={onToDateSelectedHandler}
                            calendar={persian}
                            locale={persian_fa}
                            animation="true"
                            inputClass="dateCss"
                          />
                          <Tooltip arrow followCursor title="جستجو">
                          <IconButton onClick={onSearchHandler}>
                  <SearchIcon sx={{ color: '#2979FF' }}/>
                </IconButton>
              </Tooltip>
              <Tooltip arrow followCursor title="حذف فیلترها">
                                        <IconButton onClick={onClearFilterHandler}>
                                <FilterAltOffIcon sx={{ color: '#F44336' }}/>
                              </IconButton>
              </Tooltip>
                  </AccordionDetails>
            </Accordion>


        <TabPanel value={value} index={0}>
    
    <Box sx={{ flexGrow: 1 }}>
       
       <Grid container>
                <Grid item xs={12}>
                         
                          <Accordion >
                          <AccordionSummary
                          
                  //expandIcon={<FilterAltIcon />}
                  aria-controls="panel1a-content"
               
                >
           
                 <Typography sx={{ width: '33%', flexShrink: 0 , color : '#FF3D00' }}>
                 فهرست حواله های واریزی 
          </Typography>
                     
                       
                </AccordionSummary>
                  <AccordionDetails>
                   
                  </AccordionDetails>
            </Accordion>
               </Grid>
       </Grid>
       </Box>
      <DataGrid 
        //className='headerWithFilterGrid'
        renderers={{ noRowsFallback: <EmptyRowsRendererDraft /> }}
        direction="rtl" 
        columns={columnsDrafts} 
        rows={dataSourceDrafts} 
        rowKeyGetter={rowKeyGetter}
        onScroll={handleScrollDraft}
        //headerRowHeight={100}
        style={{height : dynamicHeightDrafts}}
        //rowClass={(row) => (row.Description.includes('مانده قبل از دوره') ? 'tablehighlightClassname' : undefined)}
        />
    </TabPanel>
    <TabPanel value={value} index={1}>
    <Box sx={{ flexGrow: 1 }}>
       
       <Grid container>
                <Grid item xs={12}>
                         
                          <Accordion expanded={false}>
                          <AccordionSummary
                  //expandIcon={<FilterAltIcon />}
                  aria-controls="panel1a-content"
               
                >
           
           <Typography sx={{ width: '33%', flexShrink: 0 , color : '#FF3D00' }}>
                 فهرست چک های من 
          </Typography>
                     
                       
                </AccordionSummary>
                  <AccordionDetails>
                   
                  </AccordionDetails>
            </Accordion>
               </Grid>
       </Grid>
       </Box>
      <DataGrid 
        //className='headerWithFilterGrid'
        renderers={{ noRowsFallback: <EmptyRowsRendererCheque /> }}
        direction="rtl" 
        columns={columnsCheques} 
        rows={dataSourceCheques} 
        rowKeyGetter={rowKeyGetter}
        onScroll={handleScrollCheque}
        //headerRowHeight={100}
        style={{height : dynamicHeightCheques}}
        //rowClass={(row) => (row.Description.includes('مانده قبل از دوره') ? 'tablehighlightClassname' : undefined)}
        />
    </TabPanel>
    <TabPanel value={value} index={2}>
    <Box sx={{ flexGrow: 1 }}>
       
       <Grid container>
                <Grid item xs={12}>
                         
                          <Accordion expanded={false}>
                          <AccordionSummary
                  //expandIcon={<FilterAltIcon />}
                  aria-controls="panel1a-content"
               
                >
           
           <Typography sx={{ width: '33%', flexShrink: 0 , color : '#FF3D00' }}>
                 فهرست پرداخت های کارت خوان 
          </Typography>
                     
                       
                </AccordionSummary>
                  <AccordionDetails>
                   
                  </AccordionDetails>
            </Accordion>
               </Grid>
       </Grid>
       </Box>
      <DataGrid 
      //className='headerWithFilterGrid'
        renderers={{ noRowsFallback: <EmptyRowsRendererPos /> }}
        direction="rtl" 
        columns={columnsPoses} 
        rows={dataSourcePoses} 
        rowKeyGetter={rowKeyGetter}
        onScroll={handleScrollPos}
        //headerRowHeight={100}
        style={{height : dynamicHeightPoses}}
        //rowClass={(row) => (row.Description.includes('مانده قبل از دوره') ? 'tablehighlightClassname' : undefined)}
        />
    </TabPanel>
    <TabPanel value={value} index={3}>
    <Box sx={{ flexGrow: 1 }}>
       
       <Grid container>
                <Grid item xs={12}>
                         
                          <Accordion expanded={false}>
                          <AccordionSummary
                  //expandIcon={<FilterAltIcon />}
                  aria-controls="panel1a-content"
               
                >
           
           <Typography sx={{ width: '33%', flexShrink: 0 , color : '#FF3D00' }}>
               فهرست پرداخت های نقدی 
          </Typography>
                     
                       
                </AccordionSummary>
                  <AccordionDetails>
                   
                  </AccordionDetails>
            </Accordion>
               </Grid>
       </Grid>
       </Box>
      <DataGrid 
      //className='headerWithFilterGrid'
        renderers={{ noRowsFallback: <EmptyRowsRendererCash /> }}
        direction="rtl" 
        columns={columnsCashes} 
        rows={dataSourceCashes} 
        rowKeyGetter={rowKeyGetter}
        onScroll={handleScrollCash}
        style={{height : dynamicHeightCashes}}
        //rowClass={(row) => (row.Description.includes('مانده قبل از دوره') ? 'tablehighlightClassname' : undefined)}
        />
    </TabPanel>
    


    {receipts.loadingCheques ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }
    {receipts.loadingDrafts ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }
    {receipts.loadingPoses ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }
    {receipts.loadingCashes ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }

    </ThemeProvider>
    </>
  );
}

export default Receipts;